"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAppointmentBeenMissed = exports.hasModificatonWindowExpired = exports.hasBeenRescheduled = exports.hasBeenCanceled = exports.isRescheduleDisabled = void 0;
const moment_1 = __importDefault(require("moment"));
const isRescheduleDisabled = '@guards/ACTION_DISABLED';
exports.isRescheduleDisabled = isRescheduleDisabled;
const hasBeenCanceled = '@guards/HAS_BEEN_CANCELED';
exports.hasBeenCanceled = hasBeenCanceled;
const hasBeenRescheduled = '@guards/HAS_BEEN_RESCHEDULED';
exports.hasBeenRescheduled = hasBeenRescheduled;
const hasModificatonWindowExpired = '@guards/MODIFICATION_WINDOW_EXPIRED';
exports.hasModificatonWindowExpired = hasModificatonWindowExpired;
const hasAppointmentBeenMissed = '@guards/APPOINTMENT_MISSED';
exports.hasAppointmentBeenMissed = hasAppointmentBeenMissed;
const guards = {
    [isRescheduleDisabled]: (context) => {
        var _a;
        return !((_a = context.capabilities) === null || _a === void 0 ? void 0 : _a.isRescheduleEnabled);
    },
    [hasBeenCanceled]: (context) => {
        var _a;
        return ((_a = context.appointment) === null || _a === void 0 ? void 0 : _a.status) === 'canceled';
    },
    [hasBeenRescheduled]: (context) => {
        var _a;
        return ((_a = context.appointment) === null || _a === void 0 ? void 0 : _a.status) === 'rescheduled';
    },
    [hasModificatonWindowExpired]: (context) => {
        var _a;
        const latestCancellation = (_a = context.appointment) === null || _a === void 0 ? void 0 : _a.latest_cancellation;
        return (!!latestCancellation && !!(0, moment_1.default)(latestCancellation).isBefore((0, moment_1.default)()));
    },
    [hasAppointmentBeenMissed]: (context) => {
        var _a;
        const appointmentDate = (_a = context.appointment) === null || _a === void 0 ? void 0 : _a.start_datetime;
        return !!appointmentDate && (0, moment_1.default)(appointmentDate).isBefore((0, moment_1.default)());
    }
};
exports.default = guards;
//# sourceMappingURL=guards.main.js.map